export default "__VITE_ASSET__C4H_MtV7__"